<template>
 	<b-row>

		<b-col v-for="(departments, company) in params['team']" :key="company" class="col-12 mt-md-4 mt-lg-5 mt-3">

			<h3 class="section-title text-left m-0">{{company}}</h3>

			<b-row class="mb-3">
				<b-col v-for="(persons, department) in departments" :key="department" cols="12" md="12" class="mt-4 text-md-left text-center">
					<!-- <h6 class="section-title text-left">{{department}}</h6> -->
					
					<b-row v-for="(person, idx) in persons" :key="idx" class="mt-3">
						<b-col md="2" cols="3" sm="2" class="text-left text-md-center"> 
							<img class="about-avatar" :alt="person.avatar" :src="person.avatar">
						</b-col>
						<b-col md="10" cols="9" sm="10" class="text-left">
							<p><b class="f-gotham person-job">{{person.position}}</b><br>{{person.name}}</p>
						</b-col>	
					</b-row>

				</b-col>
			</b-row>

		</b-col>

	</b-row>
</template>
<script>
export default {
  name: 'team',
  props: ['params']
}
</script>
<style scoped>
.person-job {
	font-weight: 500;
}

</style>